App.Routers.PhoneSupport = Backbone.Router.extend({
  routes: {
    '*hash': 'index',
    '': 'index',
  },

  index: function () {
    if (App.config == null) {
      App.initVenue(null);
    }
  },
});
